export enum CounterPosition {
	Center = 'u-flex--align-center',
	Bottom = 'u-flex--align-end'
}
